Modernizr.load({
    test: Modernizr.placeholder,
    nope: 'javascript/jquery.placeholder.js',
    complete: function() {
        $('input, textarea').placeholder();
    }
});